<template>
  <div class="container">
    <div class="right">
      <div class="top">
        <a-form layout="inline" :form="form" @submit="handleSubmit" autocomplete="off">
          <a-form-item label="部门编码" style="margin-left: 10px;">
            <a-input v-decorator="['deptCode', {}]" placeholder="请输入编码" style="width: 100px" />
          </a-form-item>
          <a-form-item label="部门名称">
            <a-input v-decorator="['deptName', {}]" placeholder="请输入部门" style="width: 150px" />
          </a-form-item>
          <a-form-item label="上级部门名称" style="margin-left: 10px">
            <a-input v-decorator="['sjName', {}]" placeholder="请输入名称" style="width: 150px" />
          </a-form-item>
          <a-form-item label="组织类型" style="margin-left: 10px">
            <a-input v-decorator="['deptGlbdef3Desc', {}]" placeholder="请输入类型" style="width: 110px" />
          </a-form-item>
          <a-form-item label="创建时间" style="margin-left: 10px;">
            <a-range-picker :allowClear="true" show-time v-decorator="['search_daterange', {}]" style="width: 320px">
              <template slot="renderExtraFooter">
                选择时间
              </template>
            </a-range-picker>
          </a-form-item>
          <a-form-item style="margin-left: 20px">
            <a-button type="primary" html-type="submit">
              <a-icon type="search" />
              搜索
            </a-button>
          </a-form-item>
          <a-form-item>
            <a-button @click="resetAll">
              <a-icon type="reload" />
              重置
            </a-button>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="addDept">
              <a-icon type="plus" />
              新建
            </a-button>
          </a-form-item>
          <!-- 选择列 -->
          <a-form-item>
            <cf :oldColumns="oldColumns" :columns.sync="columns"></cf>
          </a-form-item>
        </a-form>
      </div>
      <!-- 表格 -->
      <div class="bottom" ref="table">
        <a-table :columns="columns" :data-source="data" :scroll="height" :bordered="true" :customRow="clickTableRow"
          :rowKey="(item) => item.dept_code" :loading="table_loading" :pagination="ipagination"
          @change="handleTableChange">
          <span slot="indexNo" slot-scope="text, record, index">
            {{ (ipagination.current - 1) * ipagination.pageSize + (index + 1) }}
          </span>
          <template slot="operation" slot-scope="text, record">
            <a @click.prevent="editDept(record)">
              <a-icon type="edit" />修改
            </a>
            <a @click.prevent="deleteDept(record)">
              <a-icon type="edit" />删除
            </a>
          </template>
        </a-table>
      </div>
    </div>

    <!-- 表单弹窗 -->
    <div class="modal" ref="modal">
      <a-modal :width="width" :title="title" :visible="visible" :maskClosable="false" :confirm-loading="confirmLoading"
        @ok="handleOk" @cancel="handleCancel" v-dialogDrag :getContainer="() => $refs.modal">
        <Deptdetail v-if="showNumber == 1 && visible" :currdata="curr_data" :sjDeptCode="sjDeptCode"
          :treeData="treeData" @callback="callback" @callbackErr="callbackErr"></Deptdetail>
      </a-modal>
    </div>
  </div>
</template>
<script>
// import deptTreeVue from "./deptTree.vue";
import { columns, orderBy } from "./js/colums";
import Deptdetail from "./deptdetail.vue";
import bus from "../../common/bus";

export default {
  data() {
    return {
      form: this.$form.createForm(this, { name: "deptForm" }),
      data: [],
      height: { x: 1270, y: 400 },
      ipagination: {
        pageSize: 15,
        current: 1,
        total: 0,
        showTotal: (total) => `共 ${total} 条`, // 显示总数
      },
      sort: undefined,
      table_loading: false,
      sjDeptCode: "",
      confirmLoading: false,
      upload_loading: false,
      visible: false,
      title: "新增",
      deptName: "",
      columns: columns,
      oldColumns: columns,
      orderBy: "",
      showNumber: 1,
      curr_id: undefined,
      curr_data: {},
      width: 800,
      treeData: [],
    };
  },
  mounted() {
    this.height.y = this.$refs.table.offsetHeight - 50;
    this.height.x = this.$refs.table.offsetWidth;
    let el = document.querySelector(".bottom .ant-table-body");
    if (el) {
      el.style.height = this.height.y + "px";
    }
    this.handleSubmit();
    this.getDeptTree()
  },
  methods: {
    getDeptTree() {
      this.axios.get("web/emp/getDeptTree").then((res) => {
        this.treeData = [res.data];
      });
    },

    //条件查询
    handleSubmit(e) {
      if (e) e.preventDefault();
      this.getDeptTree()
      this.form.validateFields((err) => {
        if (!err) {
          this.orderBy = orderBy;
          let query = this.form.getFieldsValue();
          let date = this.form.getFieldValue("search_daterange");
          if (date && date.length > 0) {
            query.maxTime = date[1].add(1, "d").format("YYYY-MM-DD HH:mm:ss");
            date[1].subtract(1, 'd');
            query.minTime = date[0].format("YYYY-MM-DD HH:mm:ss");
          }
          query.page = this.ipagination.current - 1;
          query.size = this.ipagination.pageSize;
          // if (this.sort) {
          //     query.sort = this.sort;
          // }
          query.sort = this.sort;
          this.table_loading = true;
          this.axios
            .get("web/department/getDeptList?sort=" + this.orderBy, { params: query })
            .then(({ data: res }) => {
              if (res.data.records) {
                this.data = res.data.records;
                this.ipagination.total = res.data.total;
              } else this.data = [];
              this.table_loading = false;
            });
        }
      });
    },
    resetAll() {
      this.form.resetFields();
      this.handleSubmit();
    },
    addDept() {
      // if (this.treeData.length == 0) {
      //     this.treeData = this.$refs.tree.treeData;
      // }
      this.title = "新增";
      this.curr_data = {};
      this.showNumber = 1;
      this.visible = true;
    },
    editDept(record) {
      // if (this.treeData.length == 0) {
      //     this.treeData = this.$refs.tree.treeData;
      // }
      this.title = "编辑";
      this.curr_data = record;
      this.showNumber = 1;
      this.width = 800;
      this.visible = true;
    },
    deleteDept(record) {
      let this_ = this;
      if (record.dept_code == "10000") {
        this_.$message.warning("初始单位部门不允许删除！");
        return;
      }
      this.$confirm({
        title: "提示",
        content: "确认删除该单位部门吗？",
        onOk() {
          this_.axios.post("web/department/delDept/" + record.dept_code).then(() => {
            this_.$message.success("删除成功!");
            this_.handleSubmit();
          });
        },
        onCancel() { },
      });
    },
    clickTableRow(record) {
      this.curr_id = record.dept_code;
    },
    handleOk() {
      this.confirmLoading = true;
      if (this.showNumber == 1) bus.$emit("ModalSubmit");
    },
    handleCancel() {
      this.visible = false;
      this.curr_data = {};
      this.confirmLoading = false;
    },
    callback() {
      this.handleCancel();
      this.handleSubmit();
      this.curr_data = {};
      this.confirmLoading = false;
    },
    callbackErr() {
      this.confirmLoading = false;
    },
    handleTableChange(pagination, filter, sort) {
      if (sort.columnKey) {
        this.sort = 'd.' + sort.columnKey + ',' + sort.order.replace('end', '')
      }
      this.ipagination = pagination;
      this.handleSubmit();
    },
  },
  computed: {
  },
  components: {
    // deptTreeVue,
    Deptdetail
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 10px 24px;
}

.right {
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 0px 10px;
}

.top {
  /* padding-left: 0px; */
  margin-bottom: 15px;
}

.center {
  margin: 20px 15px 10px 0;
}

.download.ant-btn:hover,
.download.ant-btn:focus {
  border-color: rgb(255, 186, 0);
  opacity: 0.8;
}

.download {
  background: #ffba00;
  color: #fff;
  margin-left: 15px;
}

.bottom {
  height: calc(100% - 110px);
  position: relative;
}

.container>>>.ant-table-thead>tr>th,
.container>>>.ant-table-tbody>tr>td {
  padding: 10px;
}

.container>>>.ant-table-placeholder {
  position: absolute;
  top: 42px;
  bottom: 0;
  left: 0;
  right: 0;
}

.container>>>.ant-table {
  outline: 1px solid #e8e8e8;
}

.container>>>.ant-table-body {
  overflow: auto !important;
}

.container a {
  text-decoration: none;
  margin-left: 20px;
}

.modal>>>.ant-modal-body {
  min-height: 400px;
  max-height: 650px;
  overflow: auto;
}

.modal>>>.ant-modal-body .ant-table {
  outline: 1px solid #e8e8e8;
}

.modal>>>.ant-modal-body .ant-table-placeholder {
  position: absolute;
  top: 42px;
  bottom: 0;
  left: 0;
  right: 0;
}

.modal>>>.ant-form-item {
  margin-bottom: 5px;
}
</style>